import React from "react";

import { defaultValues, model, schema } from "components/ContactForm/model";
import ContactQuestions from "./Questions";

import * as styles from "./styles.module.scss";
import clsx from "clsx";

type ContactFormProps = {
  autoHeight?: boolean;
  description?: string;
  title: string;
};

const ContactForm: React.FC<ContactFormProps> = ({ autoHeight, title, description }) => {
  const classNames = clsx(styles.contact, autoHeight && styles.autoHeight);
  return (
    <div className={classNames}>
      <div className="container small">
        <ContactQuestions
          defaultValues={defaultValues}
          formType="Contact"
          model={model}
          schema={schema}
          title={title}
          description={description}
        />
      </div>
    </div>
  );
};

export default ContactForm;
